/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Metric,
    MetricFromJSON,
    MetricFromJSONTyped,
    MetricToJSON,
    RuleAllowList,
    RuleAllowListFromJSON,
    RuleAllowListFromJSONTyped,
    RuleAllowListToJSON,
    RuleGroupRule,
    RuleGroupRuleFromJSON,
    RuleGroupRuleFromJSONTyped,
    RuleGroupRuleToJSON,
    RuleVariation,
    RuleVariationFromJSON,
    RuleVariationFromJSONTyped,
    RuleVariationToJSON,
} from './';

/**
 * Configuration which contains audiences, metrics and variations.
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * Type of statistical model to use for A/B test rules
     * @type {string}
     * @memberof Rule
     */
    stats_model_type?: RuleStatsModelTypeEnum;
    /**
     * Required sample size per variation for fixed horizon stats model
     * @type {number}
     * @memberof Rule
     */
    sample_size_per_variation?: number | null;
    /**
     * Confidence level for statistical analysis in basis points (10000 = 100%)
     * @type {number}
     * @memberof Rule
     */
    confidence_level?: number | null;
    /**
     * Minimum duration in days for the experiment
     * @type {number}
     * @memberof Rule
     */
    minimum_duration_days?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    readonly id?: number;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    layer_id?: number;
    /**
     * 
     * @type {number}
     * @memberof Rule
     */
    layer_experiment_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof Rule
     */
    name: string;
    /**
     * Type of rule.
     * @type {string}
     * @memberof Rule
     */
    type: RuleTypeEnum;
    /**
     * Type of rule distribution. Only a/b experiment can show distribution_mode field in the response
     * @type {string}
     * @memberof Rule
     */
    distribution_mode?: RuleDistributionModeEnum;
    /**
     * Additional context of the Rule
     * @type {string}
     * @memberof Rule
     */
    description?: string;
    /**
     * Indicates if the rule is enabled or not in an environment.
     * @type {boolean}
     * @memberof Rule
     */
    enabled?: boolean;
    /**
     * The percentage of the designated audiences that should get the decision rule, measured in basis points. 100 basis points = 1% traffic
     * @type {number}
     * @memberof Rule
     */
    percentage_included?: number;
    /**
     * Indicates if the rule is archived or not.
     * @type {boolean}
     * @memberof Rule
     */
    archived?: boolean;
    /**
     * List of metrics that are evaluated for the decision rules.
     * @type {Array<Metric>}
     * @memberof Rule
     */
    metrics?: Array<Metric>;
    /**
     * Group id
     * @type {string}
     * @memberof Rule
     */
    group_id?: string;
    /**
     * 
     * @type {RuleGroupRule}
     * @memberof Rule
     */
    group_rule?: RuleGroupRule;
    /**
     * Total remaining traffic allocation of the mutual exclusion group that this rule is in. This field is returned only if rule is has mutex group and user has mutex permissions
     * @type {number}
     * @memberof Rule
     */
    readonly group_remaining_traffic_allocation?: number;
    /**
     * Map of variations by variation key.
     * @type {{ [key: string]: RuleVariation; }}
     * @memberof Rule
     */
    variations?: { [key: string]: RuleVariation; };
    /**
     * The audiences that should see this rule. To target everyone, use the string \"everyone\" or omit this field. Multiple audiences can be combined with \"and\" or \"or\" using the same structure as audience conditions.
     * @type {Array<object>}
     * @memberof Rule
     */
    audience_conditions?: Array<object>;
    /**
     * User and Variation to force in the experiment
     * @type {{ [key: string]: RuleAllowList; }}
     * @memberof Rule
     */
    allow_list?: { [key: string]: RuleAllowList; };
    /**
     * A url to be used to find a particular Results page. This field is optional and returned only if rule has results
     * @type {string}
     * @memberof Rule
     */
    readonly fetch_results_ui_url?: string;
    /**
     * Timestamp when the Rule is created
     * @type {Date}
     * @memberof Rule
     */
    readonly created_time?: Date;
    /**
     * Timestamp when the Rule is updated
     * @type {Date}
     * @memberof Rule
     */
    readonly updated_time?: Date;
    /**
     * The URN for the Rule
     * @type {string}
     * @memberof Rule
     */
    readonly urn?: string;
    /**
     * User-facing Environment identifier
     * @type {string}
     * @memberof Rule
     */
    readonly environment_key?: string;
    /**
     * User-facing Unique identifier of the Flag.
     * @type {string}
     * @memberof Rule
     */
    readonly flag_key?: string;
    /**
     * The name of the Flag
     * @type {string}
     * @memberof Rule
     */
    readonly flag_name?: string;
    /**
     * The name of the Environment
     * @type {string}
     * @memberof Rule
     */
    readonly environment_name?: string;
    /**
     * status of rule. Status will change to \'Running\' when Ruleset is \'Running\'.
     * @type {string}
     * @memberof Rule
     */
    status?: RuleStatusEnum;
    /**
     * outcome of rule.
     * @type {string}
     * @memberof Rule
     */
    outcome?: RuleOutcomeEnum;
    /**
     * comment on conclusion of rule.
     * @type {string}
     * @memberof Rule
     */
    comment?: string;
    /**
     * deployed_variation_key on conclusion of rule.
     * @type {string}
     * @memberof Rule
     */
    deployed_variation_key?: string;
    /**
     * deployed_td_rule_key on conclusion of rule.
     * @type {string}
     * @memberof Rule
     */
    deployed_td_rule_key?: string;
    /**
     * The audiences that should see this deployed Targeted delivery rule.
     * @type {Array<object>}
     * @memberof Rule
     */
    deployed_td_rule_audience_conditions?: Array<object>;
    /**
     * The percentage of the designated audiences that should get the new targeted delevery rule, measured in basis points. 100 basis points = 1% traffic
     * @type {number}
     * @memberof Rule
     */
    deployed_td_rule_percentage_included?: number;
    /**
     * The id of the baseline variation, the original version of an experiment(e.g. control group) against which variations are compared.
     * @type {number}
     * @memberof Rule
     */
    baseline_variation_id?: number;
}

export function RuleFromJSON(json: any): Rule {
    return RuleFromJSONTyped(json, false);
}

export function RuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Rule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stats_model_type': !exists(json, 'stats_model_type') ? undefined : json['stats_model_type'],
        'sample_size_per_variation': !exists(json, 'sample_size_per_variation') ? undefined : json['sample_size_per_variation'],
        'confidence_level': !exists(json, 'confidence_level') ? undefined : json['confidence_level'],
        'minimum_duration_days': !exists(json, 'minimum_duration_days') ? undefined : json['minimum_duration_days'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'layer_id': !exists(json, 'layer_id') ? undefined : json['layer_id'],
        'layer_experiment_id': !exists(json, 'layer_experiment_id') ? undefined : json['layer_experiment_id'],
        'key': json['key'],
        'name': json['name'],
        'type': json['type'],
        'distribution_mode': !exists(json, 'distribution_mode') ? undefined : json['distribution_mode'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'percentage_included': !exists(json, 'percentage_included') ? undefined : json['percentage_included'],
        'archived': !exists(json, 'archived') ? undefined : json['archived'],
        'metrics': !exists(json, 'metrics') ? undefined : ((json['metrics'] as Array<any>).map(MetricFromJSON)),
        'group_id': !exists(json, 'group_id') ? undefined : json['group_id'],
        'group_rule': !exists(json, 'group_rule') ? undefined : RuleGroupRuleFromJSON(json['group_rule']),
        'group_remaining_traffic_allocation': !exists(json, 'group_remaining_traffic_allocation') ? undefined : json['group_remaining_traffic_allocation'],
        'variations': !exists(json, 'variations') ? undefined : (mapValues(json['variations'], RuleVariationFromJSON)),
        'audience_conditions': !exists(json, 'audience_conditions') ? undefined : json['audience_conditions'],
        'allow_list': !exists(json, 'allow_list') ? undefined : (mapValues(json['allow_list'], RuleAllowListFromJSON)),
        'fetch_results_ui_url': !exists(json, 'fetch_results_ui_url') ? undefined : json['fetch_results_ui_url'],
        'created_time': !exists(json, 'created_time') ? undefined : (new Date(json['created_time'])),
        'updated_time': !exists(json, 'updated_time') ? undefined : (new Date(json['updated_time'])),
        'urn': !exists(json, 'urn') ? undefined : json['urn'],
        'environment_key': !exists(json, 'environment_key') ? undefined : json['environment_key'],
        'flag_key': !exists(json, 'flag_key') ? undefined : json['flag_key'],
        'flag_name': !exists(json, 'flag_name') ? undefined : json['flag_name'],
        'environment_name': !exists(json, 'environment_name') ? undefined : json['environment_name'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'outcome': !exists(json, 'outcome') ? undefined : json['outcome'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'deployed_variation_key': !exists(json, 'deployed_variation_key') ? undefined : json['deployed_variation_key'],
        'deployed_td_rule_key': !exists(json, 'deployed_td_rule_key') ? undefined : json['deployed_td_rule_key'],
        'deployed_td_rule_audience_conditions': !exists(json, 'deployed_td_rule_audience_conditions') ? undefined : json['deployed_td_rule_audience_conditions'],
        'deployed_td_rule_percentage_included': !exists(json, 'deployed_td_rule_percentage_included') ? undefined : json['deployed_td_rule_percentage_included'],
        'baseline_variation_id': !exists(json, 'baseline_variation_id') ? undefined : json['baseline_variation_id'],
    };
}

export function RuleToJSON(value?: Rule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stats_model_type': value.stats_model_type,
        'sample_size_per_variation': value.sample_size_per_variation,
        'confidence_level': value.confidence_level,
        'minimum_duration_days': value.minimum_duration_days,
        'layer_id': value.layer_id,
        'layer_experiment_id': value.layer_experiment_id,
        'key': value.key,
        'name': value.name,
        'type': value.type,
        'distribution_mode': value.distribution_mode,
        'description': value.description,
        'enabled': value.enabled,
        'percentage_included': value.percentage_included,
        'archived': value.archived,
        'metrics': value.metrics === undefined ? undefined : ((value.metrics as Array<any>).map(MetricToJSON)),
        'group_id': value.group_id,
        'group_rule': RuleGroupRuleToJSON(value.group_rule),
        'variations': value.variations === undefined ? undefined : (mapValues(value.variations, RuleVariationToJSON)),
        'audience_conditions': value.audience_conditions,
        'allow_list': value.allow_list === undefined ? undefined : (mapValues(value.allow_list, RuleAllowListToJSON)),
        'status': value.status,
        'outcome': value.outcome,
        'comment': value.comment,
        'deployed_variation_key': value.deployed_variation_key,
        'deployed_td_rule_key': value.deployed_td_rule_key,
        'deployed_td_rule_audience_conditions': value.deployed_td_rule_audience_conditions,
        'deployed_td_rule_percentage_included': value.deployed_td_rule_percentage_included,
        'baseline_variation_id': value.baseline_variation_id,
    };
}

/**
* @export
* @enum {string}
*/
export enum RuleStatsModelTypeEnum {
    Sequential = 'sequential',
    FixedHorizon = 'fixed_horizon'
}
/**
* @export
* @enum {string}
*/
export enum RuleTypeEnum {
    TargetedDelivery = 'targeted_delivery',
    AB = 'a/b',
    MultiArmedBandit = 'multi_armed_bandit',
    ContextualMultiArmedBandit = 'contextual_multi_armed_bandit'
}
/**
* @export
* @enum {string}
*/
export enum RuleDistributionModeEnum {
    Manual = 'manual',
    StatsAccelerator = 'stats_accelerator'
}
/**
* @export
* @enum {string}
*/
export enum RuleStatusEnum {
    Draft = 'draft',
    Running = 'running',
    Paused = 'paused',
    Concluded = 'concluded'
}
/**
* @export
* @enum {string}
*/
export enum RuleOutcomeEnum {
    Positive = 'positive',
    Negative = 'negative',
    Inconclusive = 'inconclusive'
}


